import React from 'react';
import {ListFair} from './sub-view/fair';
import {BusinessLayout} from 'components/layouts/business';

class MyBusinessFair extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data1: [{item: 1}],
      data2: [{item: 1},{item: 2},{item: 3}],
      data3: [{item: 1},{item: 2}]
    }
  }

  render() {
    return (
      <BusinessLayout active='business-fair'>
        <div className='business-fair'>
          <h2 className='business-fair-title'>Hội chợ triễn lãm</h2>
          <ListFair title='Đang diễn ra' data={this.state.data1}/>
          <ListFair title='Sắp diễn ra' data={this.state.data2}/>
          <ListFair title='Đã diễn ra' data={this.state.data3} enableAddProduct={false}/>
        </div>
      </BusinessLayout>
    );
  }
}

export default MyBusinessFair;



// WEBPACK FOOTER //
// ./components/my-business/MyBusinessFair.jsx